export const mutations = {
  setIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },
  setIsOn(state, { isOn = true }) {
    state.isOn = isOn;
  },
  setKeepAlive: (state, keepAlive) => {
    state.keepAlive = keepAlive;
  },
  setIsMenu(state, { isShowMenu = true }) {
    state.isShowMenu = isShowMenu;
  },
  setIsShowPopup(state, { isShowPopup = false }) {
    state.isShowPopup = isShowPopup;
  },
  setIsFocus(state, { isFocus = false }) {
    state.isFocus = isFocus;
  },
  setModalAlertComponents(state, { modalAlertComponents }) {
    state.modalAlertComponents = modalAlertComponents;
  },
  setModalComponents(state, { modalComponents }) {
    state.modalComponents = modalComponents;
  },
  setRouteLayout(
    state,
    { isHeader = undefined, titleName = undefined, isBack = undefined, isMenu = undefined, isLogo = undefined }
  ) {
    if (isHeader !== undefined) state.routeLayout.isHeader = isHeader;
    if (titleName !== undefined) state.routeLayout.titleName = titleName;
    if (isBack !== undefined) state.routeLayout.isBack = isBack;
    if (isMenu !== undefined) state.routeLayout.isMenu = isMenu;
    if (isLogo !== undefined) state.routeLayout.isLogo = isLogo;
  },
  setTitleName(state, { titleName }) {
    state.routeLayout.titleName = titleName;
  },
  setKeywords(state, { keywords = [] }) {
    state.keywords = JSON.stringify(keywords);
    localStorage.keywords = JSON.stringify(keywords);
  },
  setInitMovePath(state, initMovePath = '') {
    state.initMovePath = initMovePath;
  }
};
